import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { trackClick } from "@/lib/analytics";

const links = [
  { id: "proses", label: "Proses" },
  { id: "upload", label: "Generate Desain" },
  { id: "galeri", label: "Galeri" },
  { id: "konsultasi", label: "Konsultasi" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    trackClick("nav_link", { target: id });
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-white/80 border-b border-sky-100 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-12 py-5">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 rounded-full bg-gradient-to-br from-sky-400 to-cyan-500 text-white flex items-center justify-center font-display text-base shadow-md shadow-sky-200">
            AT
          </span>
          <span className="font-display text-lg tracking-wider text-slate-900">
            AI<span className="text-sky-500">AT</span> Studio
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-slate-600 hover:text-sky-600 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => scrollTo("upload")}
          data-testid="nav-cta-button"
          className="hidden md:inline-block bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white font-semibold text-xs uppercase tracking-[0.2em] px-6 py-3 rounded-full shadow-lg shadow-sky-200 transition-all"
        >
          Mulai Desain
        </button>

        <button
          className="md:hidden p-2 text-slate-700"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-sky-100 px-6 py-6 space-y-4 shadow-lg">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="block text-sm uppercase tracking-[0.2em] text-slate-600 hover:text-sky-600"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("upload")}
            className="block w-full bg-sky-500 text-white text-xs uppercase tracking-[0.2em] py-3 rounded-full"
          >
            Mulai Desain
          </button>
        </div>
      )}
    </nav>
  );
}
